import React  from "react";

function Home1() {
    return(
        <>
         <div style={{ paddingLeft: 15, paddingTop: 10, paddingBottom: 10 }} className="hero-button" >
                        <span><a href="/whitepaper" className="white-paper-link-fix">White Paper</a></span>
                        <span style={{ paddingLeft: 15}} ><a  href="/roadmap">Roadmap</a></span>
                        <span style={{ paddingLeft: 15}} ><a  href="/sovereign-calculator">Sovereign Simulators</a></span>
                        <span style={{ paddingLeft: 15}} ><a  href="/test-net-dashboard">Test Net Dashboard</a></span>
                </div>
        
        </>
    );

}
export default Home1;